import { StorageError } from "@/infrastructure/errors/StorageError";

export class LocalStorageManager {
  constructor(private readonly prefix: string = "") {}

  private getKey(key: string): string {
    return this.prefix ? `${this.prefix}:${key}` : key;
  }

  get(key: string): string | null {
    try {
      return localStorage.getItem(this.getKey(key));
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to retrieve data from localStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to retrieve data from localStorage: Unknown error");
      }
    }
  }

  set(key: string, value: string): void {
    try {
      localStorage.setItem(this.getKey(key), value);
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to store data in localStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to store data in localStorage: Unknown error");
      }
    }
  }

  delete(key: string): void {
    try {
      localStorage.removeItem(this.getKey(key));
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to delete data from localStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to delete data from localStorage: Unknown error");
      }
    }
  }

  clear(): void {
    try {
      if (this.prefix) {
        // Only clear items with our prefix
        const keys = Object.keys(localStorage);
        for (const key of keys) {
          if (key.startsWith(this.prefix + ":")) {
            localStorage.removeItem(key);
          }
        }
      } else {
        localStorage.clear();
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to clear localStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to clear localStorage: Unknown error");
      }
    }
  }
}
